/**
 * מספר האורחים לחיוב. An event carries three counts: משוער (the quotation's number), סופי (the
 * confirmed count) and, for venues, מינימום לחיוב (the contract's floor). The per-person line
 * (mealCost) is billed on:
 *   - the estimated count, as always, while no minimum is set (nothing changes for existing deals);
 *   - the larger of the minimum and the final count once a minimum is set — the estimated count
 *     stands in for a final that was not entered yet.
 * One rule for every total (customer page, customers table, payment status, dashboard, Google
 * Calendar) — never compute it locally. The SQL twin lives in app.controller.ts (dashboard).
 */
export function billedGuests(event) {

    if (!event)
        return 0;

    let minimum = Number(event.minimumGuests) || 0;
    let final = Number(event.finalNumberOfGuests) || 0;
    let estimated = Number(event.estimatedNumberOfGuests) || 0;

    if (minimum > 0)
        return Math.max(minimum, final > 0 ? final : estimated);

    return estimated;
}

// the final count is below the minimum (the minimum is billed) / above the place's capacity
export function guestsWarnings(event, placeCapacity) {

    let warnings = [];

    if (!event)
        return warnings;

    let minimum = Number(event.minimumGuests) || 0;
    let final = Number(event.finalNumberOfGuests) || 0;
    let capacity = Number(placeCapacity) || 0;

    if (minimum > 0 && final > 0 && final < minimum)
        warnings.push({ code: 'belowMinimum', text: `המספר הסופי (${final}) נמוך מהמינימום לחיוב (${minimum}) - החיוב לפי המינימום` });

    let counted = final > 0 ? final : (Number(event.estimatedNumberOfGuests) || 0);

    if (capacity > 0 && counted > capacity)
        warnings.push({ code: 'overCapacity', text: `מספר האורחים (${counted}) עולה על הקיבולת של המקום (${capacity})` });

    return warnings;
}
